import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.blog;

export const blogSelectors = {
    totalItems: createSelector(selector, (blog) => blog.total_items),
    totalPages: createSelector(selector, (blog) => blog.total_pages),
    currentPage: createSelector(selector, (blog) => blog.current_page),
    pageSize: createSelector(selector, (blog) => blog.page_size),
    nextPage: createSelector(selector, (blog) => blog.next_page),
    previousPage: createSelector(selector, (blog) => blog.previous_page),
    blogs: createSelector(selector, (blog) => blog.blogs),
    selectedBlog: createSelector(selector, (blog) => blog.selectedBlog),
}